import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { apiGet } from "./api";
import "./tournament.css";

const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export default function TournamentList(){
  const history = useHistory();
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  async function load(){
    try{ const res=await apiGet("admin/tournaments"); setItems(res.data.data||[]); }
    finally{ setLoading(false); }
  }
  useEffect(()=>{load();},[]);

  return <div className="tour-page">
    <div className="tour-head pro-head">
      <div><div className="tour-eyebrow">TOURNAMENT CONTROL</div><h1>Ludo Tournaments</h1><div className="tour-sub">Create, publish, monitor rounds, standings and automatic payouts.</div></div>
      <button className="tour-btn gold large" onClick={()=>history.push("/admin/tournaments/create")}>+ Create Tournament</button>
    </div>

    {loading ? <div className="tour-card tour-empty">Loading tournaments…</div> : items.length===0 ? <div className="tour-card tour-empty">No tournament found. Create your first tournament.</div> : <div className="tour-admin-cards">
      {items.map((t)=>{
        const finance=t.finance||{};
        const maxPrize=Number(finance.advertisedPrizePool||0);
        const currentPrize=Number(finance.currentPrizePool||finance.prizePool||0);
        const fill=Math.min(100,Math.round((Number(t.humanJoined||0)/Math.max(1,Number(t.maxPlayers||1)))*100));
        return <div className="tour-admin-card" key={t._id} onClick={()=>history.push(`/admin/tournaments/${t._id}`)}>
          <div className="admin-card-top"><div><span className="tour-eyebrow">LUDO TOURNAMENT</span><h3>{t.title}</h3><p>{new Date(t.startsAt).toLocaleString()}</p></div><span className={`tour-badge ${t.status==="RUNNING"?"live":t.status==="COMPLETED"?"gold":t.status==="CANCELLED"?"red":""}`}>{String(t.status).replaceAll("_"," ")}</span></div>
          <div className="admin-card-stats"><div><small>Entry</small><strong>{money(t.entryFee)}</strong></div><div><small>Prize Pool</small><strong className="gold-text">{money(maxPrize)}</strong></div><div><small>Current Pool</small><strong>{money(currentPrize)}</strong></div><div><small>Round</small><strong>{t.currentRound||0}/{t.totalRounds}</strong></div></div>
          <div className="admin-card-progress"><div><span>{t.humanJoined||0} joined</span><span>{t.maxPlayers} seats</span></div><div className="tour-progress"><span style={{width:`${fill}%`}} /></div></div>
        </div>;
      })}
    </div>}
  </div>;
}
